import { createApp } from 'vue';
import App from './App.vue';
import router from './router';

import 'bootstrap/scss/bootstrap.scss';
import '@/assets/scss/custom.scss';
import 'bootstrap';
import 'bootstrap-icons/font/bootstrap-icons.scss';

createApp(App).use(router).mount('#app');
